import Chip from '@mui/material/Chip';
import React from 'react';
import {
  describeOfflineSyncError,
  type OfflineSyncErrors,
} from './offlineSyncErrors';

interface OfflineSyncErrorChipProps {
  errors: OfflineSyncErrors;
}

const OfflineSyncErrorChip: React.FC<OfflineSyncErrorChipProps> = ({
  errors,
}) => {
  const summary = describeOfflineSyncError(errors);

  return summary ? (
    <Chip color="softRed" label={summary.badge} size="small" />
  ) : null;
};

export default OfflineSyncErrorChip;
